/**
 * Query keys of the reading pane's conversation (ADR 0077, plan/16 §8).
 *
 * Kept beside the feature rather than in `api/queryKeys.ts` while the list
 * side of the conversation view is built in parallel; the shape follows that
 * factory's one rule regardless: **every key starts `['account', id]`**, so
 * signing an account out (`removeQueries(queryKeys.account(id).all())`) clears
 * its conversations with everything else, and an account-wide flag patch or
 * invalidation reaches them too.
 *
 *   ['account', id, 'conversation']              → every cached conversation
 *   ['account', id, 'conversation', messageId]   → the conversation of one message
 *
 * Keyed by the message that was opened, not by conversation id: the pane only
 * knows the message until the answer arrives, and any member opens the same
 * conversation, so two keys may hold the same conversation. `patchConversations`
 * patches every one of them.
 */
export const conversationKeys = {
  scope: (accountId: string) => ['account', accountId, 'conversation'] as const,
  detail: (accountId: string, messageId: string) =>
    ['account', accountId, 'conversation', messageId] as const,
};
